import React from "react";
import countryCodes from "./CountryList";

const CountrySelector = ({ selectedCountry, style, onChange }) => {
	const handleChange = (e) => {
		const index = e.target.value;
		onChange(countryCodes[index]);
	};

	return (
		<select
			style={style}
			className="country-selector"
			onChange={handleChange}
			value={
				selectedCountry
					? countryCodes.findIndex(
							(c) =>
								c.dial_code === selectedCountry.dial_code &&
								c.code === selectedCountry.code
					  )
					: ""
			}
		>
			<option
				value=""
				style={{ backgroundColor: "#F0F2F4", color: "black", padding: "2px" }}
			>
				Select Country
			</option>
			{countryCodes.map((country, index) => (
				<option
				 key={index}
				 value={index}
				 style={{ backgroundColor: "#F0F2F4", color: "black", padding: "2px" }}
				>
					{country.name}
				</option>
			))}
		</select>
	);
};

export default CountrySelector;
